/* eslint-disable max-len */
import React from 'react';
import type { SVGProps } from 'react';

type BarChartWithDollarSignIconUniqueProps = {
    width?: number | string;
    height?: number | string;
};

type BarChartWithDollarSignIconProps = SVGProps<SVGSVGElement> &
    BarChartWithDollarSignIconUniqueProps;

export const BarChartWithDollarSignIcon = function BarChartWithDollarSignIcon({
    width = 27,
    height = 26,
    ...props
}: BarChartWithDollarSignIconProps) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g id="Sales Forecast Icon 18px" clipPath="url(#clip0_2990_190091)">
                <g id="Rectangle 1101">
                    <mask id="path-1-inside-1_2990_190091" fill="white">
                        <rect x="22.167" y="14.4443" width="4.33333" height="11.5556" rx="0.5" />
                    </mask>
                    <rect
                        x="22.167"
                        y="14.4443"
                        width="4.33333"
                        height="11.5556"
                        rx="0.5"
                        fill="#D0D0D0"
                        stroke="#49565D"
                        strokeWidth="2"
                        mask="url(#path-1-inside-1_2990_190091)"
                    />
                </g>
                <path
                    id="Union"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.1431 7.18692C14.7942 7.03353 14.4452 6.92421 14.0963 6.85944V5.22217H13.0599V6.78835C12.3615 6.84057 11.8006 7.06641 11.3881 7.47488C10.9572 7.90159 10.7428 8.44057 10.7428 9.08356C10.7428 9.29809 10.7698 9.49884 10.8246 9.68512C10.8782 9.86692 10.9447 10.0282 11.0252 10.1678C11.108 10.3117 11.2251 10.4458 11.3736 10.5711C11.5171 10.6921 11.6509 10.7928 11.7749 10.8725C11.9012 10.9537 12.0691 11.038 12.2765 11.1259C12.482 11.2129 12.6556 11.2822 12.797 11.3335C12.9378 11.3845 13.1291 11.4488 13.3679 11.5256C13.629 11.6059 13.8381 11.6757 13.996 11.7351C14.1523 11.7938 14.313 11.8665 14.4783 11.9533C14.6407 12.0386 14.7598 12.1248 14.8404 12.2101C14.9219 12.2965 14.9908 12.4033 15.0461 12.5323C15.0992 12.6562 15.1268 12.7978 15.1268 12.9587C15.1268 13.31 14.996 13.5788 14.7344 13.777C14.4678 13.979 14.1152 14.0847 13.6674 14.0847C13.2783 14.0847 12.8824 14.0006 12.4791 13.8302C12.0776 13.6605 11.7148 13.4137 11.3905 13.0885L11.307 13.0047L10.5381 13.9397L10.6082 14.0085C11.322 14.7091 12.1399 15.1219 13.0599 15.2422V16.7777H14.0963V15.2569C14.807 15.1827 15.3783 14.9447 15.8001 14.5348C16.2418 14.1056 16.461 13.555 16.461 12.8922C16.461 12.6625 16.4353 12.4486 16.383 12.2511C16.3318 12.0579 16.2687 11.8879 16.1927 11.7423C16.114 11.5915 15.9988 11.4505 15.8501 11.3187C15.7065 11.1914 15.5724 11.0863 15.4479 11.0042C15.3206 10.9202 15.1448 10.8326 14.9237 10.7407C14.7041 10.6496 14.5192 10.5781 14.3693 10.5268C14.2217 10.4761 14.0132 10.4066 13.743 10.3179C13.5016 10.2375 13.3111 10.1697 13.1707 10.1143C13.0315 10.0594 12.8778 9.98933 12.7093 9.90384C12.5436 9.81973 12.4239 9.7388 12.3453 9.66253C12.2654 9.5851 12.1969 9.49039 12.1402 9.37712C12.0867 9.27034 12.0592 9.15095 12.0592 9.01706C12.0592 8.68873 12.1779 8.44517 12.4119 8.27198C12.6522 8.09405 12.978 7.99981 13.3994 7.99981C13.6945 7.99981 14.025 8.0613 14.3921 8.18744C14.7571 8.3129 15.0876 8.48708 15.384 8.70981L15.4664 8.77172L16.226 7.83931L16.1399 7.77193C15.854 7.54804 15.5214 7.35322 15.1431 7.18692Z"
                    fill="#49565D"
                />
                <path
                    id="Subtract"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.02 7.22217C21.9786 3.5132 18.0328 1 13.5 1C6.87258 1 1.5 6.37258 1.5 13C1.5 17.5536 4.03638 21.5149 7.77344 23.548V24.674C3.46518 22.5566 0.5 18.1246 0.5 13C0.5 5.8203 6.3203 0 13.5 0C18.6042 0 23.0214 2.94168 25.1487 7.22217H24.02ZM13.5377 25.9999H13.4623C13.4749 26 13.4874 26 13.5 26C13.5126 26 13.5251 26 13.5377 25.9999Z"
                    fill="#49565D"
                />
                <g id="Rectangle 1098">
                    <mask id="path-4-inside-2_2990_190091" fill="white">
                        <rect x="16.04" y="17.3335" width="4.33333" height="8.66667" rx="0.5" />
                    </mask>
                    <rect
                        x="16.04"
                        y="17.3335"
                        width="4.33333"
                        height="8.66667"
                        rx="0.5"
                        fill="#D0D0D0"
                        stroke="#49565D"
                        strokeWidth="2"
                        mask="url(#path-4-inside-2_2990_190091)"
                    />
                </g>
                <g id="Rectangle 1100">
                    <mask id="path-5-inside-3_2990_190091" fill="white">
                        <rect x="9.91602" y="20.2222" width="4.33333" height="5.77778" rx="0.5" />
                    </mask>
                    <rect
                        x="9.91602"
                        y="20.2222"
                        width="4.33333"
                        height="5.77778"
                        rx="0.5"
                        fill="#D0D0D0"
                        stroke="#49565D"
                        strokeWidth="2"
                        mask="url(#path-5-inside-3_2990_190091)"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_2990_190091">
                    <rect width="26" height="26" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};
BarChartWithDollarSignIcon.__tags = ['bar', 'chart', 'dollar sign. diagram'] as string[];
